import React from 'react';
import filterConditionalKeyValues from '../../utils/filterConditionalKeyValues';
import Box from '../Box/Box';

export type TSpinnerProps = {
  absolute?: boolean;
  className?: string;
};

const Spinner = ({ absolute, ...rest }: TSpinnerProps) => {
  const conditionalProps = filterConditionalKeyValues({
    modifiers: [absolute ? 'absolute' : ''],
  });
  return (
    <Box {...rest} as="div" name="Spinner" {...conditionalProps}>
      <Box as="div" name="dots" parent="Spinner" />
    </Box>
  );
};

export default Spinner;
